<template>
  <el-dialog
    title="完善身份信息"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="200px"
            size="small"
    >
      <el-form-item
                    prop="identitynum"
                    label="请输入身份证号码"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.identitynum"></el-input>
      </el-form-item>
          <el-form-item
                  prop="mobileNo"
                  label="请输入手机号码"
                  :rules="[{ required: true, message: '不能为空'}]"
          >
              <el-input v-model="form.mobileNo"></el-input>
      </el-form-item>
      <el-form-item label="身份证件照正面" prop="idcards_front"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_front" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList4"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove2"
                :on-success="handlePictureCardPreview2">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="身份证件照反面" prop="idcards_back"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_back" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList5"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove3"
                :on-success="handlePictureCardPreview3">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>



      <el-form-item >
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:60%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "sfzForm",
    components:{
    },
  props: {
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
          mobileNo:'',
          identitynum:'',
          idcards_front: '',
          idcards_back:''
      },
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        fileList4: [],
        fileList5: [],
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();

        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",util.cookies.get('agentid'));
        agentService.getPhotoIdcards(formData4).then(data => {
            if(data!=null && data!=""){
                this.form.identitynum = data.identitynum;
                this.form.mobileNo = data.mobileno;
                 if (data.idcards_front != null && data.idcards_front != ""&& data.idcards_front != "null") {
                        this.fileList4 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.idcards_front}]
                     this.form.idcards_front = data.idcards_front;
                    }

                 if (data.idcards_back != null && data.idcards_back != ""&& data.idcards_back != "null") {
                        this.fileList5 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.idcards_back}]
                     this.form.idcards_back = data.idcards_back;
                    }

            }
        });

    },

      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove3(file) {
          this.form.idcards_back = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview3(file) {
          console.log("=======file.url=========="+file.url);
          this.form.idcards_back = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove2(file) {
          this.form.idcards_front = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview2(file) {
          console.log("=======file.url=========="+file.url);
          this.form.idcards_front = file.url;
          this.dialogVisible = true;
      },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                      this.loading = true;
                      agentService.updatePhotoIdcards({ ...this.form,agentid:util.cookies.get('agentid')})
                          .then(data => {
                              this.loading = false;
                              console.info("-----------"+data);
                              if(data=='000'){
                                  this.$message("修改成功");
                                  this.dialogVisible = false;
                              this.$emit("submit");
                              }else if(data=='001'){
                                 this.$message("用户未登陆");
                              }else{
                                  this.$message("修改失败");
                              }
                          });
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

